<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16.000213623046875"
    height="16"
    viewBox="0 0 16.000213623046875 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.00020997138977,8L8.00020997138977,0C12.42019997138977,0,16.00019997138977,3.58,16.00019997138977,8L8.00020997138977,8ZM1.0304882523897705,8.00008C1.0304882523897705,4.48008,3.6304899713897707,1.58008,7.00048997138977,1.08008L7.00048997138977,9.00008L14.92049997138977,9.00008C14.43049997138977,12.3901,11.530499971389771,15.0001,8.01048997138977,15.0001C4.1604899713897705,15.0001,1.0304882523897705,11.8701,1.0304882523897705,8.00008Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'PieChart',
} as DefineComponent
</script>
